import React from "react";
import * as XLSX from "xlsx";
import LoadingButton from "@material-ui/lab/LoadingButton";
import { Icon } from "@iconify/react";
import documentExport from "@iconify/icons-carbon/document-export";
import { useSnackbar } from "src/components/snackbar";
import { subtareasApi } from "src/services/subtareasApi";
export default function ExportToExcelSubTareas(props) {
  const { filename, sheetName, sucursalId, empleadoRut, rolObtenido } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [triggerExportEmpleado, { isLoading: isExportingEmpleado }] =
    subtareasApi.useLazyExportSubTareasEmpleadoQuery();
  const [triggerExportTodas, { isLoading: isExportingTodas }] =
    subtareasApi.useLazyExportSubTareasTodasQuery();

  const isExporting = isExportingEmpleado || isExportingTodas;

  const exportar = async () => {
    try {
      const isAdmin = ["SUPER_ADMIN", "ADMIN", "SUPERVISOR"].includes(
        rolObtenido,
      );
      let subtareasCompletas;

      // Determinar qué endpoint usar según el rol
      if (isAdmin) {
        subtareasCompletas = await triggerExportTodas({
          sucursal: sucursalId,
        }).unwrap();
      } else {
        subtareasCompletas = await triggerExportEmpleado({
          sucursal: sucursalId,
          empleado: empleadoRut,
        }).unwrap();
      }

      if (!subtareasCompletas || subtareasCompletas.length === 0) {
        enqueueSnackbar("No hay datos que exportar", {
          variant: "warning",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        });
        return;
      }

      // Alerta si hay más de 10.000 registros
      if (subtareasCompletas.length > 10000) {
        enqueueSnackbar(
          `Se exportarán ${subtareasCompletas.length.toLocaleString()} subtareas. Esto puede tardar más de lo habitual.`,
          {
            variant: "info",
            anchorOrigin: { vertical: "bottom", horizontal: "right" },
            autoHideDuration: 5000,
          },
        );
      }

      // Preparar datos para Excel
      const subtareasParaExcel = subtareasCompletas.map((subtarea) => [
        subtarea.refCliente,
        subtarea.nombreCliente,
        subtarea.nombreTarea,
        subtarea.tipoTarea,
        subtarea.nombre,
        subtarea.fechaInicio,
        subtarea.fechaTermino,
        subtarea.estado,
        subtarea.nombreEmpleado,
        subtarea.diasTranscurridos,
        subtarea.diasLimites || "",
      ]);

      // Crear Excel
      let worksheet = XLSX.utils.aoa_to_sheet([
        [
          "RUT Cliente",
          "Nombre Cliente",
          "Nombre Tarea",
          "Tipo Tarea",
          "Nombre SubTarea",
          "Fecha Inicio",
          "Fecha Término",
          "Estado",
          "Nombre Empleado",
          "Días Transcurridos",
          "Días Límite",
        ],
        ...subtareasParaExcel,
      ]);

      let new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, worksheet, sheetName);
      XLSX.writeFile(new_workbook, `${filename}.xlsx`);

      enqueueSnackbar(
        `${subtareasCompletas.length} subtareas exportadas exitosamente`,
        {
          variant: "success",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        },
      );
    } catch (error) {
      console.error("Error al exportar subtareas:", error);
      enqueueSnackbar(error?.data?.message || "Error al exportar subtareas", {
        variant: "error",
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
      });
    }
  };

  return (
    <LoadingButton
      variant="contained"
      onClick={exportar}
      startIcon={<Icon icon={documentExport} />}
      style={{ minWidth: "170px" }}
      loading={isExporting}
    >
      Exportar subtareas
    </LoadingButton>
  );
}
